import { render, staticRenderFns } from "./DetailAprovalPenerimaDana.vue?vue&type=template&id=74d59d72&scoped=true"
import script from "./DetailAprovalPenerimaDana.vue?vue&type=script&lang=js"
export * from "./DetailAprovalPenerimaDana.vue?vue&type=script&lang=js"
import style0 from "./DetailAprovalPenerimaDana.vue?vue&type=style&index=0&id=74d59d72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d59d72",
  null
  
)

export default component.exports